import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectFade, Autoplay } from 'swiper/modules';
import { useLanguage } from '../contexts/LanguageContext';
import 'swiper/css';
import 'swiper/css/effect-fade';

export function Hero() {
  const { data } = useLanguage();
  const slideshowData = data.slideshow;

  if (!slideshowData.active) return null;

  return (
    <section id="hero" className="relative h-screen w-full overflow-hidden">
      <Swiper
        modules={[EffectFade, Autoplay]}
        effect="fade"
        speed={1500}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        loop={true}
        className="h-full w-full"
      >
        {slideshowData.nodes.map((slide) => (
          <SwiperSlide key={slide.id} className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-black/50 to-black/30 z-10" />
            <img
              src={slide.image}
              alt={slide.title}
              className="absolute inset-0 w-full h-full object-cover transform scale-110 transition-transform duration-[10000ms] slide-image"
            />
            <div className="relative z-20 h-full flex flex-col justify-center items-center text-white text-center px-4 max-w-4xl mx-auto">
              <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 animate-slide-title leading-tight">
                {slide.title}
              </h1>
              <p className="text-lg md:text-xl lg:text-2xl animate-slide-subtitle leading-relaxed">
                {slide.subtitle}
              </p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}